export default __webpack_public_path__ + "static/media/growth.d7c6314a.png";